module.exports = __webpack_public_path__ + "img/zhiyuanzheicon1.1641520899224.png";